import { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Tooltip, IconButton, InputBase, Typography } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UsePictures } from "./UsePictures";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import { rsGotoLast, rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import RefreshIcon from "@mui/icons-material/Refresh";
import { UseProduct } from "../product/UseProduct";

function Pictures() {
  const { ResetCache } = UseProduct();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const { getPictureList } = UsePictures();
  const [pictureRes, setPictureRes] = useState();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [progress, setProgress] = useRecoilState(rsProgress);

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getPictureList(
      myPc,
      search,
      (images) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(images.pageCondition.totalPage);
          return;
        }
        setPictureRes(images);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "id",
      width: 70,
      headerName: "ID",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "faName",
      headerName: " نام فارسی ",
      headerAlign: "center",
      width: 300,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.faName}
          </Typography>
        );
      },
    },
    {
      field: "imageJPG",
      headerName: "imageJPG",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "image360",
      headerName: "image360",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "imagePng",
      headerName: "imagePng",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "عملیات",
      sortable: false,
      width: 110,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());
                  return navigate("/productimages/editpicture", {
                    state: {
                      model: cellValues.row,
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                      name: cellValues.row.faName,
                    },
                  });
                }}
              >
                <EditIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="کش">
              <IconButton
                onClick={() => {
                  setProgress(true);
                  ResetCache(cellValues.row.id, () => {
                    setProgress(false);
                  });
                }}
              >
                <RefreshIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              fullWidth
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/productimages" }],
      }}
    >
      {pictureRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={pictureRes.pageCondition.pageCount}
          rows={pictureRes.images}
          paginationMode="server"
          page={pictureRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            pictureRes?.pageCondition.totalItemCount
              ? pictureRes.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              nofab: true,
              rowCount: pictureRes?.pageCondition.totalItemCount
                ? pictureRes.pageCondition.totalItemCount
                : "",
              isLtr: true,
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}

export default Pictures;
